import {
  FETCH_POPULAR_FAQS,
  FETCH_POPULAR_FAQS_FULFILLED,
  FETCH_POPULAR_FAQS_REJECTED,
  FETCH_FAQ_CONTENT,
  FETCH_FAQ_CONTENT_FULFILLED,
  FETCH_FAQ_CONTENT_REJECTED,
  FETCH_FAQ_BY_SEARCH,
  FETCH_FAQ_BY_SEARCH_FULFILLED,
  FETCH_FAQ_BY_SEARCH_REJECTED
} from '../actions/types'

export default function reducer (state = {
  faq: null,
  faqLoading: false,
  faqError: false,
  popularfaqs: [],
  popularfaqsLoading: false,
  popularfaqsError: false,
  searchLoading: false,
  searchError: false,
  searchResults: [],
  searchTerm: null,
  searchTotalResults: 0
}, action) {
  switch (action.type) {
    case FETCH_FAQ_CONTENT: {
      return { ...state, faqError: false, faqLoading: true }
    }
    case FETCH_FAQ_CONTENT_FULFILLED: {
      return { ...state, faq: action.payload, faqLoading: false }
    }
    case FETCH_FAQ_CONTENT_REJECTED: {
      return { ...state, faqLoading: false, faqError: true }
    }
    case FETCH_POPULAR_FAQS: {
      return { ...state, popularfaqsError: false, popularfaqsLoading: true }
    }
    case FETCH_POPULAR_FAQS_FULFILLED: {
      return { ...state, popularfaqs: action.payload, popularfaqsLoading: false }
    }
    case FETCH_POPULAR_FAQS_REJECTED: {
      return { ...state, popularfaqsLoading: false, popularfaqsError: true }
    }
    case FETCH_FAQ_BY_SEARCH: {
      return { ...state, searchError: false, searchLoading: true }
    }
    case FETCH_FAQ_BY_SEARCH_FULFILLED: {
      return {
        ...state,
        searchResults: action.payload.results.autoSuggest.faq,
        searchTerm: action.payload.searchTerm,
        searchTotalResults: (action.payload.results.autoSuggest.faq.length ? action.payload.results.autoSuggest.faq[0].total : 0),
        searchLoading: false
      }
    }
    case FETCH_FAQ_BY_SEARCH_REJECTED: {
      return { ...state, searchLoading: false, searchError: true }
    }
    default:
      return state
  }
}
